<nb-card *ngIf="!billPDF && !pdfFailed && !pdfAbsent" [nbSpinner]="true" nbSpinnerStatus="info">
  <nb-card-body>Loading PDF...</nb-card-body>
</nb-card>

<p *ngIf="pdfFailed" style="color: red;">Failed to load PDF.</p>
<p *ngIf="pdfAbsent" style="color: red;">PDF not present.</p>

<!-- <nb-card *ngIf="pdfFailed">
  <nb-card-body>Failed to load PDF.</nb-card-body>
</nb-card>
<nb-card *ngIf="pdfAbsent">
  <nb-card-body>PDF not present.</nb-card-body>
</nb-card> -->
<div style="height: 1000px" *ngIf="!pdfAbsent && !pdfFailed && billPDF">
  <ng2-pdfjs-viewer *ngIf="billPDF" [pdfSrc]="encodeURIComponent(billPDF)" ></ng2-pdfjs-viewer>
</div>
